'use client';

import { useRef } from 'react';
import Image from 'next/image';
import { ProcessStepsCarouselDesktopItem } from './item';
import { useVerticalScrollCarousel } from '@/hooks/useVerticalScrollCarousel';
import type { ProcessStepsProps } from '../type';
import { defaultTitle } from '../constants';

const INITIAL_HEIGHT = 1070;

export function ProcessStepsCarouselDesktop({ steps, title }: ProcessStepsProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const stickyContainer = useRef<HTMLDivElement>(null);
  const { activeIndex, progress, handleItemClick, totalHeight } = useVerticalScrollCarousel(
    containerRef,
    stickyContainer,
    INITIAL_HEIGHT,
    steps.content.data.length
  );

  return (
    <div ref={containerRef} style={{ height: `${totalHeight}px` }}>
      <div ref={stickyContainer} className="sticky top-0">
        <h2
          className="section-title text-center text-brand-text-button pt-24 [&_i]:section-subtitle @md:[&_br]:hidden"
          dangerouslySetInnerHTML={{ __html: title || defaultTitle }}
        />
        <div className="grid grid-cols-2 gap-12.5 rounded-4xl bg-[linear-gradient(253.32deg,#2563EB_-6.11%,#0369A1_49.31%,#05195E_96.19%)] overflow-clip p-20 mt-14">
          <div className="flex flex-col justify-center">
            {(steps.content?.data || []).map((item, index) => (
              <ProcessStepsCarouselDesktopItem
                key={`${item.position}-${index}`}
                order={index + 1}
                title={item.title}
                subtitle={item.subtitle}
                isActive={index === activeIndex}
                progress={index === activeIndex ? progress : 0}
                onClick={() => handleItemClick(index)}
              />
            ))}
          </div>

          <div className="relative overflow-hidden">
            {steps.content.data.map((item, index) => (
              <div
                key={`image-${index}-${item.position}`}
                className={`absolute inset-0 transition-opacity duration-700 rounded-2xl overflow-hidden ${
                  index === activeIndex ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <Image
                  src={item.image}
                  alt={item.title}
                  width={600}
                  height={600}
                  className="w-full h-full object-cover"
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessStepsCarouselDesktop;
